import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { Button } from "./ui/button";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`fixed bottom-24 md:bottom-8 right-4 md:right-8 z-30 transition-all duration-500 ease-out ${
        isVisible
          ? "opacity-100 translate-y-0 scale-100"
          : "opacity-0 translate-y-4 scale-90 pointer-events-none"
      }`}
    >
      <Button
        onClick={scrollToTop}
        size="icon"
        className="h-12 w-12 rounded-full bg-primary/90 backdrop-blur-sm text-white shadow-lg hover:bg-primary hover:scale-110 hover:-translate-y-1 active:scale-95 transition-all duration-300 group"
        style={{ boxShadow: "0 4px 14px rgba(230, 0, 18, 0.3)" }}
        aria-label="Back to top"
      >
        <ChevronUp className="h-6 w-6 transition-transform duration-300 group-hover:-translate-y-0.5" />
      </Button>
    </div>
  );
};

export default BackToTop;
